
<mat-dialog-content class="customer-dialog">
      <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Group Code</mat-label>
      <input matInput [(ngModel)]="tgcode" (keyup)="retriveTreatmentGroupLookUP()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Group Name</mat-label>
      <input matInput [(ngModel)]="tgname" (keyup)="retriveTreatmentGroupLookUP()">
    </mat-form-field>

  </div>

    <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
              <thead>
            <tr>
                <th style="width: 30%;">Treatment Group Code</th>
                <th style="width: 100%;">Treatment Group Name</th>

                <th style="width: 20%;">Choose</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let tg of treatmentGroup; let i = index">
                <td data-column="tgcode">{{tg.tgcode}}</td>
                <td data-column="tgname">{{tg.tgname}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectTreatmentGroup(tg)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
